import { useLayout } from '@approvalmax/ui/src/components';
import { hocs as pageHocs } from 'modules/page';
import { FC } from 'react';
import { useHideCompanyHeader } from 'shared/components';

import PageSkeleton from '../components/PageContent/PageSkeleton';
import PageError from '../containers/PageError/PageError';
import { useLeavePage } from '../hooks/useLeavePage';
import useOldRequestsSupportingPageData from '../hooks/useOldRequestsSupportingPageData';

export const OldRequestsSupportingPage: FC = () => {
    useLayout({ hasHeader: true, hasDrawer: true });
    useHideCompanyHeader();
    useLeavePage();

    const { isError } = useOldRequestsSupportingPageData();

    if (isError) {
        return <PageError />;
    }

    return <PageSkeleton />;
};

export default pageHocs.withProtected({ Page: OldRequestsSupportingPage });
